import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { TextFieldWrapper } from 'src/components';
import { Box, Button, Error, Stack } from 'src/components/matchbox';
import { TranslatableText } from 'src/components/text';
import { Form } from 'src/components/tracking';
import { FORMS } from 'src/constants';
import { trimWhitespaces } from 'src/helpers/string';
import { required } from 'src/helpers/validation';

export class SsoLoginForm extends React.Component {
  render() {
    const { loginPending, loginError, pristine, handleSubmit, disabledInput, disabledSubmit } =
      this.props;
    const buttonText = loginPending ? 'Logging In' : 'Log In';

    return (
      <React.Fragment>
        {loginError && (
          <Error
            error={
              <>
                {/* eslint-disable-next-line local/restrict-translatable-text -- loginError is already wrapped in TranslatableText when needed */}
                {loginError}
                <TranslatableText>. Please contact Bird support for assistance.</TranslatableText>
              </>
            }
          />
        )}
        <Form onSubmit={handleSubmit} id="sso-login-form">
          <Stack>
            <Field
              name="username"
              id="username"
              label="Email or Username"
              data-sensitive={true}
              normalize={trimWhitespaces}
              component={TextFieldWrapper}
              validate={required}
              disabled={disabledInput}
            />
            <Box>
              <Button
                variant="primary"
                submit
                disabled={loginPending || pristine || disabledSubmit}
              >
                <TranslatableText>{buttonText}</TranslatableText>
              </Button>
            </Box>
          </Stack>
        </Form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  initialValues: {
    username: auth.username
  }
});

export default connect(mapStateToProps)(reduxForm({ form: FORMS.SSO })(SsoLoginForm));
